

export const SampleUrls =
{
    intro : {
        webArLink : "/view/webar/intro",
        modelUrl : "/embed/webar/intro/super.gltf",
        modelUrliOs : "/embed/webar/intro/nice.usdz" 
    },
    sample1 : 
    {
        webArLink : "/view/webar/superimpose",
    },
    sample2 : 
    {
        webArLink : "/view/webar/rams_speaker",
    },
    sample3 : 
    {
        webArLink : "/view/webar/mannequin",
    }
}


export function GetAzurePath(path){
    return "https://sonnentherme.blob.core.windows.net/" + path;
}

export const AzurePaths = {
    UserImage : "userimage/",
    UserImageThumb : "userimagethumbnail/"
}

export function GetPath(path){
    return "/" + path;
}

export const Paths = {
    //BasePath : 'https://sonnentherme.azurewebsites.net/',


    Login : 'api/User/AuthenticateWeb',
    Register : 'api/User/RegisterWeb',

    User  : 'api/User/MyProfile',
    Users : 'api/User/GetUsersAdmin',
    ActiveUsers : 'api/User/ActiveSessions',

    RefreshToken : 'api/User/RefreshAuth',
    DeleteUser  : 'api/User/{id}',
    GetUserById : 'api/User/{id}',
    UpdateSpecificUser : 'api/User/UpdateSpecificUser',
    AddUser : 'api/User/AddUser',

    SendPushNotification : 'api/Notification/SendPushNotification',

    Ranking : 'api/Slide/MainInfo',


    GetChart : 'api/Analytics/GetChart',
    GetDailyDistribution : 'api/Analytics/GetDailyDistribution',
    GetChartMeta : 'api/Analytics/GetChartMeta',
    ChartSumByEventType : 'api/Analytics/ChartSumByEventType',

    UserSetting  :'api/UserSetting' ,
    AssetLink  :'api/Asset/GetAssetLink' ,
    AssetLinks  :'api/Asset/GetAssetLinks' ,
    DeleteAssetLink  :'api/Asset/DeleteLink' ,
    DuplicateAssetLink  :'api/Asset/DuplicateLink' ,
    PostAssetLink  :'api/Asset/Upload' ,
    MoveAssetLink  :'api/Asset/MoveAssetLink' ,
    Asset  : 'api/Asset' ,
    AssetTransformation  :'api/AssetTransformation' ,
    SetAssetLinkBackground  :'api/Asset/SetBackground' ,
    RemoveAssetLinkBackground  :'api/Asset/RemoveBackground' ,

    Publish  :'api/Asset/PublishDraft' ,
    Unpublish  :'api/Asset/Unpublish' ,
    Restore  :'api/Asset/Restore' ,

    

    DeleteAccount  :'api/User/DeleteAccount',
    ChangeName  :'api/User/ChangeName' ,
    ChangeEmail  :'api/User/ChangeEmail' ,
    ChangePassword  :'api/User/ChangePassword' ,
    ChangeLink  :'api/User/ChangeLink' ,
    
    GetAuthToken : 'api/User/GetToken',
    ForgotPassword : 'api/User/ForgotPassword',
    ResetPassword : 'api/User/ResetPassword',
    ConfirmEmail : 'api/User/ConfirmEmail',
    
    NewPaymentMethod  :'api/Payment/NewPaymentMethod' ,
    Plans : 'api/Payment/GetPlans',
    SubscribeTo : 'api/Payment/SubscribeTo',
    CancelSubscriptions : 'api/Payment/CancelSubscriptions',
    BeginCheckoutSession : 'api/Payment/BeginCheckoutSession',
    GetPaymentStatus : 'api/Payment/GetPaymentStatus',

    Media : 'api/Media/GetAll'

    
 }

 
export const BrandingOptions = {
    Sonnentherme : "sonnentherme",
    Vame : "vame"
};

export const Branding = BrandingOptions.Sonnentherme;


export const Validation = {

    Form : {
        UserLink : { required: true, maxLength: 50, minLength: 2, pattern: /^[0-9a-zA-Z$\-_+!*'(),]+$/ },
        UserName : { required: true, maxLength: 50, minLength: 2, pattern: /^[0-9a-zA-Z$\-_+!*'(),]+$/ },
        Email : { required: true, maxLength: 50, minLength: 2, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i },
        Password : { required: true, maxLength: 50, minLength: 6} /* , pattern: /^[0-9a-zA-Z$\-_+!*'(),]+$/  */
    }
 
}

export const SettingType = {
    draft : 0,
    published : 1
}

export const TransformationStatus = {
    inUpload : 0,

    waitingToBeProcessed : 1,

    downloadForProcessing : 2,

    beingProcessed : 3,


    processedWithWarnings : 4,

    processedWithErrors : 5,

    processedSuccessfully : 6
}